(() => {
  document.querySelectorAll('[data-collection-sort-control]').forEach((control) => {
    const select = control.querySelector('[data-catalog-sort]');
    const trigger = control.querySelector('[data-catalog-sort-trigger]');
    const menu = control.querySelector('[data-catalog-sort-menu]');
    const value = control.querySelector('#CatalogSortValue');
    if (!select || !trigger || !menu || !value) return;
    const options = [...select.options].map((option) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.setAttribute('role', 'option');
      button.tabIndex = -1;
      button.dataset.value = option.value;
      const label = document.createElement('span');
      label.textContent = option.textContent;
      const check = document.createElement('b');
      check.textContent = '✓';
      check.setAttribute('aria-hidden', 'true');
      button.append(label, check);
      menu.append(button);
      return button;
    });
    const sync = () => {
      value.textContent = select.selectedOptions[0]?.textContent || '';
      options.forEach(option => option.setAttribute('aria-selected', String(option.dataset.value === select.value)));
    };
    const close = (restore = false) => {
      menu.hidden = true;
      control.classList.remove('is-open');
      trigger.setAttribute('aria-expanded', 'false');
      if (restore) trigger.focus();
    };
    const open = () => {
      menu.hidden = false;
      control.classList.add('is-open');
      trigger.setAttribute('aria-expanded', 'true');
      (options.find(option => option.dataset.value === select.value) || options[0])?.focus();
    };
    trigger.addEventListener('click', () => menu.hidden ? open() : close());
    trigger.addEventListener('keydown', event => {
      if (event.key === 'ArrowDown' || event.key === 'ArrowUp') { event.preventDefault(); open(); }
    });
    options.forEach((option, index) => {
      option.addEventListener('click', () => {
        select.value = option.dataset.value;
        select.dispatchEvent(new Event('change', { bubbles: true }));
        close(true);
      });
      option.addEventListener('keydown', event => {
        const key = event.key;
        if (!['ArrowDown', 'ArrowUp', 'Home', 'End'].includes(key)) return;
        event.preventDefault();
        const next = key === 'Home' ? 0 : key === 'End' ? options.length - 1 : (index + (key === 'ArrowDown' ? 1 : -1) + options.length) % options.length;
        options[next].focus();
      });
    });
    control.addEventListener('keydown', event => {
      if (event.key === 'Escape' && !menu.hidden) { event.preventDefault(); event.stopPropagation(); close(true); }
    });
    document.addEventListener('click', event => { if (!control.contains(event.target)) close(); });
    document.addEventListener('focusin', event => { if (!control.contains(event.target)) close(); });
    select.addEventListener('change', sync);
    sync();
    select.hidden = true;
    control.querySelector('label')?.setAttribute('for', trigger.id);
    trigger.hidden = false;
  });
})();
